// src/apolloClient.js
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { HttpLink } from '@apollo/client';
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

// Create an HTTP link for queries and mutations
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_BROKER_HTTP_URL,
});

// Create a WebSocket link for subscriptions
const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.REACT_APP_BROKER_WS_URL,
    options: {
      reconnect: true,
      lazy: true,
      keepAlive: 12000
    },
  })
);

// use of split to direct requests to the appropriate link
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

// Create the Apollo Client
const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

export default client;